export function parseRoute(pathname = window.location.pathname) {
  const inviteMatch = pathname.match(/^\/i\/([^/]+)/);
  if (inviteMatch) {
    return {
      view: "invite",
      inviteId: decodeURIComponent(inviteMatch[1]),
    };
  }

  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] === "entry" && parts[1]) {
    return {
      view: parts[2] === "media" ? "media" : "entry",
      entryId: decodeURIComponent(parts[1]),
      mediaIndex: Number.parseInt(parts[3] || "0", 10) || 0,
    };
  }

  return { view: "feed" };
}

export function tokenFromHash(hash = window.location.hash) {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return params.get("t") || "";
}

export function entryPath(entryId) {
  return `/entry/${encodeURIComponent(entryId)}`;
}

export function mediaPath(entryId, mediaIndex) {
  return `/entry/${encodeURIComponent(entryId)}/media/${mediaIndex}`;
}
